import config from "./config";
import events from "./constants/events";
import { loadEpiTranslationsFromCurrentPage } from "./constants/translations";
import ConversationListWebComponent from "./web-components/conversation-list";
import NewConversationWebComponent from "./web-components/new-conversation";

const addScript = (scriptUrl: string) => {
	const head = document.getElementsByTagName("head")[0];
	const script = document.createElement("script");

	script.type = "text/javascript";
	script.setAttribute("crossorigin", "anonymous");
	script.src = scriptUrl;

	head.appendChild(script);
};

const pushDatalayer = (step: string, part: string) => {
	const data = {
		event: "MyPages Process Event",
		processInfo: {
			name: "mypages",
			subname: "secureMessage",
			part,
			processStep: {
				mainStep: step,
			},
		},
	};

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(data);
};

window.addEventListener("load", () => {
	pushDatalayer("viewed", "");
	customElements.define("new-conversation", NewConversationWebComponent);
	customElements.define("conversation-list", ConversationListWebComponent);

	window.addEventListener("if-secure-messaging-new-message-started", () => {
		pushDatalayer("started", "newMessage");
	});

	window.addEventListener("if-secure-messaging-new-message-sent", () => {
		pushDatalayer("confirmed", "newMessage");
		window.dispatchEvent(new Event(events.newMessageSentOrCancelled));
	});

	window.addEventListener("if-secure-messaging-reply-message-started", () => {
		pushDatalayer("started", "reply");
	});

	window.addEventListener(
		"if-secure-messaging-reply-sent-to-conversation",
		() => {
			pushDatalayer("confirmed", "reply");
		},
	);

	if (config.customerComponent && config.customerComponent.host) {
		addScript(
			`${config.customerComponent.host}mypages-customer-prefs/secure-messaging.js`,
		);
	}
});

loadEpiTranslationsFromCurrentPage();
